import { render, staticRenderFns } from "./orderServicerSettlement.vue?vue&type=template&id=c441a654&"
import script from "./orderServicerSettlement.vue?vue&type=script&lang=ts&"
export * from "./orderServicerSettlement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports